import React from 'react';
import { Card, Row, Col } from 'react-bootstrap';
import Skeleton from '@mui/material/Skeleton';
import { Paper } from '@mui/material';

const CommonCardListShimmer = ({ count = 6 }) => {
  return (
    <div className="p-3 ms-3 rounded w-100">
      <Row className="g-4">
        {[...Array(count)].map((_, index) => (
          <Col key={index} md={6} lg={4}>
            <Card className="h-100 shadow-sm ">
              <Card.Body>
                <Skeleton variant="text" width="60%" height={18} className="mb-2" />
                <Skeleton variant="text" width="80%" height={28} className="mb-3" />
                <Skeleton variant="text" width="100%" height={48} className="mb-3" />
                <Skeleton variant="rectangular" width="100%" height={140} className="mb-3" />
                <Skeleton variant="text" width="50%" height={20} className="mb-2" />
                <Skeleton variant="text" width="40%" height={20} className="mb-2" />
                <Skeleton variant="text" width="60%" height={20} />
              </Card.Body>
              <Card.Footer className="d-flex justify-content-between">
                <Skeleton variant="circular" width={30} height={30} />
                <Skeleton variant="circular" width={30} height={30} />
                <Skeleton variant="circular" width={30} height={30} />
              </Card.Footer>
            </Card>
          </Col>
        ))}
      </Row>
    </div>
  );
};

export default CommonCardListShimmer;
